export const InfoCircle = () => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2ZM1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6ZM5.5 4C5.5 3.72386 5.72386 3.5 6 3.5H6.005C6.28114 3.5 6.505 3.72386 6.505 4C6.505 4.27614 6.28114 4.5 6.005 4.5H6C5.72386 4.5 5.5 4.27614 5.5 4ZM5 6C5 5.72386 5.22386 5.5 5.5 5.5H6C6.27614 5.5 6.5 5.72386 6.5 6V7.5C6.77614 7.5 7 7.72386 7 8C7 8.27614 6.77614 8.5 6.5 8.5H6C5.72386 8.5 5.5 8.27614 5.5 8V6.5C5.22386 6.5 5 6.27614 5 6Z"
                fill="#0F1113"
            />
        </svg>
    );
};
